import { render, staticRenderFns } from "./TradeView.vue?vue&type=template&id=781416a0&scoped=true"
import script from "./TradeView.vue?vue&type=script&lang=js"
export * from "./TradeView.vue?vue&type=script&lang=js"
import style0 from "./TradeView.vue?vue&type=style&index=0&id=781416a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781416a0",
  null
  
)

export default component.exports